<template>
    <div class>
        <STable ref="tableref" :url="url" :selection="true" :columns="columns" :handles="handles" :query="query" :toolbar="toolbar" label-width="100px" />
        <el-dialog v-dialogDrag title="批量更新" :visible.sync="dialogVisible" :close-on-click-modal="false" width="60%" center>
            <STable ref="tableref2" :url="url" :selection="true" :columns="columns" :toolbar="toolbar2" label-width="100px" />
            <div class="btns" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
                <el-button @click="cancel">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialogDrag title="远程升级" :visible.sync="dialogVisible2" :close-on-click-modal="false" width="40%" center>
            <el-form ref="form" :model="form" :rules="rules" label-width="130px" style="width: 90%;margin:0 auto;">
                <el-form-item label="电枪编码" prop="connectorId" style="width:100%">
                    <div>{{ form.connectorId }}</div>
                </el-form-item>
                <el-form-item label="升级版本" prop="version" style="width: 90%;">
                    <el-select v-model="form.version" filterable placeholder="请选择升级版本号" style="width:100%;">
                        <el-option v-for="item in versionList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-top:30px;text-align: center;" label-width="0px">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host';
import fieldFilter from '@/utils/fieldFilter.js';
import { TreeDataNull } from '@/utils/tool.js';
export default {
    name: 'Dianzhuangguanli',
    components: {},
    data() {
        return {
            url: '/station/equipment/page',
            dialogVisible: false,
            updataDate: {},
            columns: [
                {
                    label: '充电枪名称',
                    prop: 'connectorName',
                },
                {
                    label: '归属电站',
                    prop: 'stationName',
                },
                {
                    label: '充电枪编码',
                    prop: 'connectorCode',
                },
                // {
                //   label: "充电桩编号",
                //   prop: "equipmentId",
                // },
                {
                    label: '电桩品牌',
                    prop: 'brandName',
                },
                {
                    label: '电桩型号',
                    prop: 'brandModel',
                },
                {
                    label: '充电枪功率',
                    prop: 'power',
                },
                {
                    label: '版本号',
                    prop: 'version',
                    template: (index, record) => {
                        return record.version ? decodeURIComponent(record.version) : '';
                    },
                },
                {
                    label: '启停状态',
                    prop: 'disable',
                    template: function (index, reocrd) {
                        return reocrd.disable
                            ? "<div class='circle red'></div><span>停用</span>"
                            : "<div class='circle green'></div><span>启用</span>";
                    },
                },
                {
                    label: '工作状态',
                    prop: 'workStatus',
                },
                {
                    label: '在线状态',
                    prop: 'online',
                    template: function (index, record) {
                        return record.online ? '在线' : '离线';
                    },
                },
            ],
            dialogVisible2: false,
            rowid: '',
            id: '',
            form: {
                connectorId: '',
                version: '',
            },
            rules: {
                version: [{ required: true, message: '请选择升级版本', trigger: 'change' }],
            },
            // 操作栏
            handles: {
                width: 450,
                btns: [
                    {
                        label: '详情',
                        icon: 'el-icon-view',
                        permission: 'pile.equipment.details',
                        handle: resp => {
                            this.$router.push({
                                path: './pileDetail',
                                query: { connectorId: resp.connectorId, connectorCode: resp.connectorCode },
                            });
                        },
                    },
                    {
                        label: '校价',
                        permission: 'pile.equipment.Price',
                        // style: "color:#00FF00",
                        url: '/evserv/newApi/checkPrice',
                        method: 'get',
                        before: (index, record) => {
                            return { connectorID: record.connectorCode };
                        },
                        handle: resp => {
                            if (resp === null) {
                                this.$notify({
                                    title: '成功',
                                    message: '校价成功',
                                    type: 'success',
                                });
                            }
                        },
                    },
                    {
                        label: '校时',
                        permission: 'pile.equipment.time',
                        style: 'color:#00FF00',
                        url: '/evserv/newApi/checkTime',
                        method: 'get',
                        before: (index, record) => {
                            return { connectorID: record.connectorCode };
                        },
                        handle: resp => {
                            if (resp === null) {
                                this.$notify({
                                    title: '成功',
                                    message: '校时成功',
                                    type: 'success',
                                });
                            }
                        },
                    },
                    {
                        label: '远程重启',
                        permission: 'pile.equipment.restart',
                        // style: "color:#00FF00",
                        url: '/evserv/newApi/reStart',
                        method: 'get',
                        before: (index, record) => {
                            return { connectorID: record.connectorCode };
                        },
                        handle: resp => {
                            if (resp === null) {
                                this.$notify({
                                    title: '成功',
                                    message: '远程重启成功',
                                    type: 'success',
                                });
                            }
                        },
                    },
                    {
                        label: '远程启动',
                        permission: 'pile.equipment.start',
                        isConfirm: true,
                        confirmText: '确定要远程启动该充电枪充电吗？',
                        url: '/evserv/newApi/start_charge',
                        method: 'post',
                        before: (index, record) => {
                            return { connectorId: record.connectorCode };
                        },
                        handle: resp => {
                            this.$notify({
                                title: '成功',
                                message: '远程启动充电指令已下发',
                                type: 'success',
                            });
                            this.$refs.tableref.queryTable();
                        },
                    },
                    {
                        label: '修改',
                        permission: 'pile.equipment.update',
                        handle: resp => {
                            this.$router.push({
                                path: './chargingPile',
                                query: { data: resp.connectorId },
                            });
                        },
                    },
                    {
                        label: '停用',
                        permission: 'pile.equipment.Enable',
                        style: 'color:red',
                        getLabel: function (record) {
                            return record.disable ? '启用' : '停用';
                        },
                        url: '/station/equipment/status',
                        method: 'post',
                        isConfirm: true,
                        confirmText: '是否确定执行本操作？',
                        before: function (index, record) {
                            const ids = [];
                            ids.push(record.connectorId);
                            const p = {
                                ids: ids,
                            };
                            return p;
                        },
                        handle: resp => {
                            this.$refs.tableref.queryTable();
                        },
                    },
                    {
                        label: '删除',
                        permission: 'pile.equipment.delete',
                        style: 'color:red',
                        confirmText: '确认删除该终端？删除后终端及电桩将一同删除',
                        url: '/station/equipment',
                        method: 'delete',
                        isConfirm: true,
                        before: (index, record) => {
                            const arr = [];
                            arr.push(record.connectorId);
                            return {
                                ids: arr,
                            };
                        },
                        handle: () => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                            });
                            this.$refs.tableref.queryTable();
                        },
                    },
                    {
                        label: '远程升级',
                        permission: 'pile.equipment.upgrade',
                        method: 'post',
                        before: (index, record) => {
                            this.form = {
                                connectorId: '',
                                version: '',
                            };
                            this.dialogVisible2 = true;
                        },
                        handle: resp => {
                            this.id = resp.connectorId;
                            this.form.connectorId = resp.connectorCode;
                        },
                    },
                ],
            },
            query: [
                {
                    label: '充电枪名称',
                    prop: 'connectorName',
                    placeholder: '请输入充电枪名称',
                },
                {
                    label: '归属电站',
                    prop: 'stationName',
                    placeholder: '请输入归属电站',
                },
                {
                    label: '充电枪编码',
                    prop: 'connectorCode',
                    placeholder: '请输入充电枪编码',
                },
                {
                    label: '电桩编码',
                    prop: 'equipmentCode',
                    placeholder: '请输入电桩编码',
                },
                {
                    label: '电桩品牌',
                    prop: 'brandName',
                    placeholder: '请输入电桩品牌',
                    type: 'select',
                    data: [],
                },
                {
                    label: '电桩型号',
                    prop: 'brandModule',
                    placeholder: '请选择电桩型号',
                    type: 'cascader',
                    data: [],
                    props: {
                        label: 'name',
                        value: 'id',
                        checkStrictly: true,
                    },
                },
                {
                    label: '充电枪功率',
                    prop: 'power',
                    placeholder: '请输入充电枪功率',
                    type: 'select',
                    data: [
                        {
                            label: '交流 7kw',
                            value: '7',
                        },
                        {
                            label: '交流 21kw',
                            value: '21',
                        },
                        {
                            label: '交流 42kw',
                            value: '42',
                        },
                        {
                            label: '直流 30kw',
                            value: '30',
                        },
                        {
                            label: '直流 60kw',
                            value: '60',
                        },
                        {
                            label: '直流 90kw',
                            value: '90',
                        },
                        {
                            label: '直流 120kw',
                            value: '120',
                        },
                        {
                            label: '直流 240kw',
                            value: '240',
                        },
                    ],
                },
                {
                    label: '启停状态',
                    prop: 'disable',
                    placeholder: '请选择启停状态',
                    type: 'select',
                    data: [
                        {
                            label: '启用',
                            value: '0',
                        },
                        {
                            label: '停用',
                            value: '1',
                        },
                    ],
                },
                {
                    label: '工作状态',
                    prop: 'status',
                    placeholder: '请选择工作状态',
                    type: 'select',
                    data: [
                        {
                            label: '离网',
                            value: '0',
                        },
                        {
                            label: '空闲',
                            value: '1',
                        },
                        {
                            label: '占用（未充电）',
                            value: '2',
                        },
                        {
                            label: '占用（充电中）',
                            value: '3',
                        },
                        {
                            label: '故障',
                            value: '255',
                        },
                    ],
                },
                {
                    label: '电桩类型',
                    prop: 'eleType',
                    placeholder: '请选择电桩类型',
                    type: 'select',
                    data: [
                        {
                            label: '交流',
                            value: '2',
                        },
                        {
                            label: '直流',
                            value: '1',
                        },
                    ],
                },
                {
                    label: '在线状态',
                    prop: 'onlineFlag',
                    placeholder: '请选择在线状态',
                    type: 'select',
                    data: [
                        {
                            label: '在线',
                            value: true,
                        },
                        {
                            label: '离线',
                            value: false,
                        },
                    ],
                },
            ],
            toolbar: [
                {
                    label: '新增',
                    permission: 'pile.equipment.add',
                    type: 'primary',
                    handle: resp => {
                        this.$router.push('./addPile');
                    },
                },
                {
                    label: '下载模板',
                    icon: 'el-icon-download',
                    permission: 'pile.equipment.download',
                    type: 'primary',
                    handle: resp => {
                        const url = HOST + '/station/equipment/import/template';
                        $.fileDownload(url, {
                            httpMethod: 'get',
                            data: {
                                token: window.localStorage.getItem('token'),
                            },
                            failCallback: (html, url) => {
                                this.$notify({
                                    title: '失败',
                                    message: '模板下载失败',
                                    type: 'error',
                                });
                            },
                        });
                    },
                },
                {
                    label: '导入',
                    icon: 'el-icon-upload2',
                    permission: 'pile.equipment.Import',
                    type: 'primary',
                    isUpload: true,
                    url: HOST + '/station/equipment/import',
                    method: 'post',
                    option: {
                        loading: false,
                        headers: {
                            token: window.localStorage.getItem('token'),
                            companyId: window.localStorage.getItem('curCompanyId'),
                        },
                        beforeUpload: file => {
                            this.toolbar[2].option.loading = true;
                        },
                        onSuccess: (response, file, fileList) => {
                            this.toolbar[2].option.loading = false;
                            if (!response.code) {
                                this.$refs.tableref.queryTable();
                                this.$notify({
                                    title: '成功',
                                    message: '批量导入成功',
                                    type: 'success',
                                });
                                return;
                            }
                            this.$notify({
                                title: '失败',
                                message: response.message,
                                type: 'error',
                            });
                        },
                        onError: (err, file, fileList) => {
                            this.toolbar[2].option.loading = false;
                            this.$notify({
                                title: '失败',
                                message: '批量导入失败',
                                type: 'error',
                            });
                        },
                        onProgress: (event, file, fileList) => {},
                    },
                },
                {
                    label: '导出二维码',
                    icon: 'el-icon-download',
                    permission: 'pile.equipment.QRcode',
                    type: 'primary',
                    handle: resp => {
                        const url = HOST + '/station/equipment/export';
                        const queryData = this.$refs.tableref.getQueryData();
                        queryData.token = window.localStorage.getItem('token');
                        queryData.companyId = window.localStorage.getItem('curCompanyId');
                        $.fileDownload(url, {
                            httpMethod: 'get',
                            data: queryData,
                            failCallback: (response, html, url) => {
                                this.$notify({
                                    title: '失败',
                                    message: '二维码导出失败或无可导出数据',
                                    type: 'error',
                                });
                            },
                        });
                    },
                },
                {
                    label: '批量校价',
                    type: 'primary',
                    icon: ' ',
                    url: '/evserv/newApi/checkPrice',
                    permission: 'pile.equipment.Prices',
                    onSelect: true,
                    disabled: true,
                    before: records => {
                        const arr = [];
                        records.map(ele => {
                            arr.push(ele.connectorCode);
                        });
                        const arr2 = [];
                        arr.sort().map(function (value, index) {
                            if (arr2.indexOf(value) === -1) {
                                arr2.push(value);
                            }
                        });
                        this.rowid = arr2.join(',');
                        return { connectorID: this.rowid };
                    },
                    handle: resp => {
                        if (resp === null) {
                            this.$notify({
                                title: '成功',
                                message: '校价成功',
                                type: 'success',
                            });
                        }
                    },
                },
                {
                    label: '批量校时',
                    icon: ' ',
                    type: 'primary',
                    permission: 'pile.equipment.timing',
                    url: '/evserv/newApi/checkTime',
                    onSelect: true,
                    disabled: true,
                    before: records => {
                        const arr = [];
                        records.map(ele => {
                            arr.push(ele.connectorCode);
                        });
                        const arr2 = [];
                        arr.sort().map(function (value, index) {
                            if (arr2.indexOf(value) === -1) {
                                arr2.push(value);
                            }
                        });
                        this.rowid = arr2.join(',');
                        return { connectorID: this.rowid };
                    },
                    handle: resp => {
                        if (resp === null) {
                            this.$notify({
                                title: '成功',
                                message: '校时成功',
                                type: 'success',
                            });
                        }
                    },
                },
                // {
                //   label:'批量升级',
                //   permission: "",
                //   type: "primary",
                //   before:record=>{
                //     this.dialogVisible = true;
                //   }
                // }
            ],
            toolbar2: [],
            versionList: [],
        };
    },
    computed: {},
    mounted() {
        this.selectVersion();
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {
        this.$store.dispatch('form/handle', {
            url: '/station/equipment/getBrandTree',
            method: 'get',
            callback: resp => {
                if (resp && resp.length > 0) {
                    this.query[5].data = TreeDataNull(resp);
                }
            },
        });
        this.$store.dispatch('form/handle', {
            url: '/station/equipment/getBrandList',
            callback: res => {
                for (var i = 0; i < res.length; i++) {
                    this.query[4].data.push({ label: '', value: '' });
                    this.query[4].data[i].label = res[i].name;
                    this.query[4].data[i].value = res[i].name;
                }
            },
        });
    }, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    methods: {
        // 获取版本列表
        selectVersion() {
            const data = {};
            this.$store.dispatch('form/handle', {
                url: '/alarm/firmware/selectFirmware',
                data: data,
                method: 'get',
                callback: resp => {
                    const arr = [];
                    resp.forEach(item => {
                        arr.push({
                            label: item.version,
                            value: item.id,
                        });
                    });
                    this.versionList = arr;
                    console.log(this.versionList);
                },
            });
        },
        cancel() {
            this.dialogVisible = false;
            this.dialogVisible2 = false;
        },
        async save() {
            try {
                // 必填校验
                await Promise.all([this.$refs.form.validate()]);
            } catch (error) {
                return;
            }
            const data = {
                id: this.id,
                version: this.form.version,
            };
            this.$store.dispatch('form/handle', {
                url: '/evserv/newApi/reUpdate',
                data: data,
                method: 'post',
                callback: resp => {
                    this.dialogVisible2 = false;
                    this.$refs.tableref.queryTable();
                    if (resp === null) {
                        this.$notify({
                            title: '成功',
                            message: '远程升级指令已下发，请稍后查看版本号',
                            type: 'success',
                        });
                    }
                },
            });
        },
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/plantManagement/pilemanagement.vue